import { render, staticRenderFns } from "./EditPaymentMessageComponent.vue?vue&type=template&id=546ead1d&"
import script from "./EditPaymentMessageComponent.vue?vue&type=script&lang=js&"
export * from "./EditPaymentMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports